import { ActCode } from './ActCode';
import { RequiredDetails } from '../requiredDetail.type';
import { getFeatureConfig } from '../../../../userCustomization/featureToggle';
import { REQUIRED_DETAILS_FOR_INTERNISTS } from '../../../../userCustomization/featureNames';
import dateHospitalisation from '../DateHospitalisation/dateHospitalisation';
import intensiveCareDiagnostic from '../IntensiveCareDiagnostic/intensiveCareDiagnostic';
import intensiveCareExceptionalCircumstances from '../ExceptionalCircumstances/intensiveCareExceptionalCircumstances';
import HOSPITAL_ACTIVITY_AREA_MAP from '../../../../shared/ramq/domainValues/activityAreas';

export default class ActCode34 implements ActCode {
  // eslint-disable-next-line no-unused-vars
  constructor(private act: any) {}

  getRequiredDetails(): RequiredDetails {
    const requiredDetails: RequiredDetails = [];

    if (getFeatureConfig(REQUIRED_DETAILS_FOR_INTERNISTS, false)) {
      requiredDetails.push(dateHospitalisation, intensiveCareDiagnostic);
    }

    if (this.act.activityArea === HOSPITAL_ACTIVITY_AREA_MAP.intensiveCareUnit) {
      requiredDetails.push(intensiveCareExceptionalCircumstances);
    }

    return requiredDetails;
  }
}
